import { methods, request } from "./base";

const labTestApis = {
  getLabTests: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/tests/catalog_list",
      payload: data,
    }),
  getCartInfo: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/tests/get_cart_info",
      payload: data,
    }),
  addLabTestToCart: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/tests/add_to_cart",
      payload: data,
    }),
  getLabTestCart: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/tests/list_cart",
      payload: data,
    }),
  removeItemFromCart: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/tests/remove_from_cart",
      payload: data,
    }),
  searchLabTests: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/tests/search_catalog_list",
      payload: data,
    }),
  getLabTestDetails: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/tests/catalog_details",
      payload: data,
    }),
  getPatientList: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/tests/patient_members_list",
      payload: data,
    }),
  getAppointmentSlot: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/tests/get_appointment_slots",
      payload: data,
    }),
  bookTest: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/tests/book_test",
      payload: data,
    }),
  confirmOrder: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/tests/confirm_order",
      payload: data,
    }),
  orderSummary: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/tests/order_summary",
      payload: data,
    }),
  rescheduleLabTest: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/tests/rescheduled_lab_test",
      payload: data,
    }),
  cancelLabTest: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/tests/cancel_lab_test",
      payload: data,
    }),
};

export default labTestApis;
